import { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { BranchesOutlined } from "@ant-design/icons";
import { Col, Row, Table } from "antd";
import Breadcrumbs from "../../components/Breadcrumbs";
import Title from "../../components/Title";
import DashboardPages from "../../Dashboard/DashboardPages";
import {
  TYPE_GET_DATE,
  defineColumnsDetailTableBicagame,
} from "../../../helper/const";
import { useSelector } from "react-redux";
import { selectorDataBicagame } from "../../../redux/selector";
import { useDispatch } from "react-redux";
import {
  formatDataDailyRevenueChartBicagame,
  getDateChangeTime,
} from "../../../helper/helper";
import FilterTime from "../../components/FilterTime";
import styled from "styled-components";
import { apiRevenueBicagame } from "../../../api/Bicagame";
import { getDataRevenueBicagame } from "../../../redux/Future/Bicagame/action";
import DailyRevenueChartMagicWheel from "../../components/DailyRevenueChartMagicWheel";

export default function RevenueBicagameVina() {
  const dispatch = useDispatch();

  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  useEffect(() => {
    dispatch(getDataRevenueBicagame(apiRevenueBicagame(startDate, endDate)));
  }, [startDate, endDate]);

  const { revenue = {} } = useSelector(selectorDataBicagame);
  const dataList = revenue.result?.vinaphone;

  let data = (dataList || []).map(item => ({
    ...item,
    "Total Revenue": item.total_revenue,
    "Total Charge": item.register_success + item.renew_success,
  }));

  const dataTable = [...data].sort((a, b) => new Date(b.report_date) - new Date(a.report_date));

  const dataDailyRevenueChart = formatDataDailyRevenueChartBicagame(data);

  const dataDetail = {
    data,
    xField: "report_date",
    yField: ["Total Revenue", "Total Charge"],
  };
  return (
    <Container>
      <Breadcrumbs data={["Bicagame","Vinaphone"]} />
      <div className="container-dashboard">
        <div className="d-flex justify-content-end mb-2">
          <FilterTime
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
          />
        </div>

        <Row className="panel panel-sortable mt-4">
          <Title titleName="Overview">
            <BranchesOutlined />
          </Title>
          <Col span={24} className="container-revenue">
            <DashboardPages
              dataDashboard={dataDetail}
              isHiddenContainer
              width={1100}
            />
          </Col>
          <div className="container-dashboard pt-0">
            <Row className="panel panel-sortable">
              <Title titleName="Daily Revenue Chart">
                <BranchesOutlined />
              </Title>
              <div className="container-revenueOfChannelChart">
                <div className="revenueOfChannelChart">
                  <DailyRevenueChartMagicWheel dataRevenueChart={dataDailyRevenueChart} />
                </div>
              </div>
            </Row>
          </div>                
          <Col span={24} className="mt-4 container-item">
            <h4 className="pt-3 pe-3 pb-2">Overview statistics table:</h4>
            <Row>
              <Col span={24}>
                <Table
                  columns={defineColumnsDetailTableBicagame}
                  dataSource={dataTable}
                  pagination={false}
                  summary={(pageData) => {
                    const fields = [
                      "register_success",
                      "renew_success",
                      "total_cancel",
                      "register_revenue",
                      "renew_revenue",
                      "total_revenue",
                    ];

                    const totals = fields.map((field) =>
                      pageData.reduce((sum, row) => sum + (row[field] || 0), 0)
                    );

                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>
                          <p>Total</p>
                        </Table.Summary.Cell>
                        {totals.map((value, i) => (
                          <Table.Summary.Cell key={fields[i]} index={i + 1}>
                            {value.toLocaleString("en-US")}
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    );
                  }}
                />

              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-table-container {
    overflow-x: auto;
  }

  .panel-sortable {
  }

  .container-revenue {
    width: 100%;
    padding: 0.25rem 2rem;
  }

  @media (max-width: 1200px) {
    .container-revenue {
      width: 100%;
      padding: 0.25rem 1rem;
    }
  }

  @media (max-width: 768px) {
    .chart-container__unitel {
      margin-top: 1rem;
    }
  }
`;
